export default __webpack_public_path__ + "static/media/beta-register-hero.428ed04c.jpg";